import { AddressType } from "./generalTypes";

export type PurchaseOrderType = {
  id: string;
  name: string;
  proforma_invoice_number: string;
  status?: string | null;
  po_fulfillment_events: PofeType[];
};

export enum PofeStatusTypeEnum {
  DISPUTE = "Dispute",
  GOODS_IN_PREPARATION_MANUFACTURING = "Goods in preparation/manufacturing",
  INTRA_EUROPE_TRANSPORTATION_LAST_MILE_DELIVERY = "Intra-europe transportation/Last mile delivery",
  DELIVERED = "Delivered",
  CANCELLED = "Cancelled",
  WRITE_OFF = "Write off",
}

export enum PofePaymentStatusTypeEnum {
  UNPAID = "Unpaid",
  PAID = "Paid",
}

export type PofeType = {
  id: string;
  name: string;
  incoterm: string;
  incoterm_location: string;
  balance_payment_status: string;
  handover_date: string | null;
  actual_pickup_date: string | null;
  scheduled_pickup_date: string | null;
  deadline_for_handover: string | null;
  delivery_address: AddressType;
  pickup_address: AddressType;
  container_number?: string | null;
  pick_up_comment?: string | null;
  batch_number?: string | null;
  pofeps: PofepType[];
  // Additional fields from API that may be included
  status?: PofeStatusTypeEnum | string;
  main_warehouse_opening_times:
    | {
        sunday: string;
        monday: string;
        tuesday: string;
        wednesday: string;
        thursday: string;
        friday: string;
        saturday: string;
      }
    | null
    | undefined;
  attachments?: AttachmentType[]; // Uploaded files from the client
};

export type PofepType = {
  id: string;
  name: string;
  product_name: string;
  quantity: number;
};

export type AttachmentType = {
  content_document_id: string;
  content_size: number;
  created_date: string;
  file_extension: string;
  id: string;
  last_modified_date: string;
  path_on_client: string;
  title: string;
  version_data: string; // Base64 encoded file content
};

export type FileRequestType = {
  title: string;
  path_on_client: string;
  version_data: string;
  content_size?: number; // File size in bytes
};

export enum IncotermTypeEnum {
  DDP = "DDP",
  DAP = "DAP",
  DDUP = "DDUP",
  DDU = "DDU",
  DDP_DAP = "DDP/DAP",
  DDP_DDU = "DDP/DDU",
  DAP_DDU = "DAP/DDU",
  CIF = "CIF",
  CFR = "CFR",
  FOB = "FOB",
}
